module.exports = __webpack_public_path__ + "img/graph1-w.ebca0cde.svg";